import { render, staticRenderFns } from "./barcode-scanner.vue?vue&type=template&id=b0be4cdc&scoped=true"
import script from "./barcode-scanner.vue?vue&type=script&lang=js"
export * from "./barcode-scanner.vue?vue&type=script&lang=js"
import style0 from "./barcode-scanner.vue?vue&type=style&index=0&id=b0be4cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0be4cdc",
  null
  
)

export default component.exports